import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TableModule } from 'primeng/table';
import { ButtonColumnType, DataColumnType, IButtonColumn, IDataColumn } from '../../../../../shared/interfaces/custom-work/customTable';
import { CustomTableTypeChecker } from '../../../../../shared/classes/custom-table-type-checker';
import { TooltipModule } from 'primeng/tooltip';
import { ButtonModule } from 'primeng/button';
import { FilterMatchMode } from 'primeng/api';
import { firstValueFrom, forkJoin } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'tr[tableHeader]',
  standalone: true,
  imports: [CommonModule, TableModule, TooltipModule, ButtonModule],
  templateUrl: './table-header.component.html',
  styleUrl: './table-header.component.scss'
})
export class TableHeaderComponent<T = any> {

  @Input() columns !: (IDataColumn | IButtonColumn<T>)[];

  tabletypeChecker = CustomTableTypeChecker;
  readonly ButtonColumnType = ButtonColumnType;
  readonly DataColumnType = DataColumnType;
  matchModeOptions: any[] = [];
  trans: any = {};

  constructor(private readonly _t: TranslateService) {
  }

  ngOnInit(): void {
    this.translate().then(() => {
      this.matchModeOptions = [
        { label: this.trans.contains, value: FilterMatchMode.CONTAINS },       // LIKE '%value%'
        { label: this.trans.equals, value: FilterMatchMode.EQUALS },           // =
        { label: this.trans.startsWith, value: FilterMatchMode.STARTS_WITH }, // LIKE 'value%'
        { label: this.trans.endsWith, value: FilterMatchMode.ENDS_WITH },     // LIKE '%value'
      ];
    });
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      contains: this._t.get('primeng.contains'),
      equals: this._t.get('primeng.equals'),
      startsWith: this._t.get('primeng.startsWith'),
      endsWith: this._t.get('primeng.endsWith'),
    }));
  }

  getHeaderOrientationClass(col: IDataColumn): string {
    switch (col.dataType) {
      case DataColumnType.MONEY:
        return 'justify-content-center';
      case DataColumnType.NUMBER:
        return 'justify-content-center';
      case DataColumnType.DATE:
        return 'justify-content-center';
      case DataColumnType.CHECK:
        return 'justify-content-center';
      default:
        return 'justify-content-start';
    }
  }

  getDisabled(col: (IDataColumn | IButtonColumn<T>)): boolean{
    if(col.headerBtn?.disabled){
      return col.headerBtn.disabled;
    }else if(col.headerBtn?.getDisabled){
      return col.headerBtn.getDisabled();
    }
    return false;
  }
}
